import { HttpErrorResponse } from '@angular/common/http';
import { IFinancialLineItemExtendedDTO } from '@modeso/types__aumico-lib-settings-be';
import { Subject } from 'rxjs';

export interface IfinancialLineItemFormData {
    financialLineItem: IFinancialLineItemExtendedDTO;
    errorMessage: Subject<HttpErrorResponse>;
}
